// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"8cdb2c26","242":"93c544e6","260":"2c16be88","408":"6d5a2d17","457":"9d344348","593":"775f2ffd","721":"95eb0399","733":"228866e8","747":"88ad8a0f","894":"2f11d831"}[chunkId] + ".chunk.js";
};